package com.eladfinish.bible.contest.logging

import io.github.aakira.napier.Antilog
import io.github.aakira.napier.LogLevel

actual class HyperlinkedAntilog actual constructor() : Antilog() {

    private val tagMap: Map<LogLevel, String> = mapOf(
        LogLevel.VERBOSE to "💜 VERBOSE",
        LogLevel.DEBUG to "💚 DEBUG",
        LogLevel.INFO to "💙 INFO",
        LogLevel.WARNING to "💛 WARN",
        LogLevel.ERROR to "❤️ ERROR",
        LogLevel.ASSERT to "💞 ASSERT",
    )

    actual override fun performLog(
        priority: LogLevel,
        tag: String?,
        throwable: Throwable?,
        message: String?,
    ) {
        val baseLogString = "${tagMap[priority]} ${tag ?: "app"} - $message"
        println(
            if (throwable != null) "$baseLogString\n${throwable.stackTraceToString()}" else baseLogString
        )
    }
}
